var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDeleteLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_delete_light_svg__a",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_delete_light_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_delete_light_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_delete_light_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 16c0 7.732-6.268 14-14 14S2 23.732 2 16C2 8.269 8.268 2 16 2s14 6.269 14 14",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    d: "M23.778 9.636l-1.414-1.414L16 14.584 9.636 8.221 8.222 9.635 14.586 16l-6.364 6.365 1.414 1.415L16 17.413l6.364 6.364 1.414-1.413L17.414 16z"
  })))));
}

export default SvgIconDeleteLight;